import { createSlice } from "@reduxjs/toolkit";
import { getUserDetails, login, updateUserProfileInfo } from "./thunk";
const storedAuthState = localStorage.getItem("isLoggedIn") === "true";
const initialState = {
  isLoggedIn: storedAuthState,

  accessToken: null,
  refreshToken: null,
  customToken: "",

  uuid: null,
  employeeID: "",
  // password: "",
  userRole: "",
  locationCode: "",
  locationName: "",

  loginResponse: null,
  loginResponseStatus: null,

  userDetailsResponse: null,
  userDetailsResponseStatus: null,

  updateProfileInfoResponse: null,
  updateProfileInfoResponseStatus: null,

  loading: true,
  selectedPage: "all",

  profileTabSelected: "overview",
};

const normalizeRole = (role) => {
  if (!role) return "";
  return String(role).trim().toUpperCase();
};

const getSsoRole = (payload) => {
  if (!payload) return "";

  const permissionRole = payload.permissions?.role;
  if (permissionRole) return permissionRole;

  return (
    payload.role ||
    payload.role_type ||
    payload.user_role ||
    payload.userRole ||
    payload.user_type ||
    payload.userType ||
    ""
  );
};

const shouldForceHrRole = (state, payload) => {
  const ssoRole = normalizeRole(getSsoRole(payload));
  const existingRole = normalizeRole(state.userRole);
  return ssoRole === "HR" || existingRole === "HR";
};

const authSlice = createSlice({
  name: "auth",
  initialState: initialState,
  reducers: {
    setLoggedIn: (state, action) => {
      state.isLoggedIn = action.payload;
      localStorage.setItem("isLoggedIn", action.payload);
    },
    setSelectedPage: (state, action) => {
      state.selectedPage = action.payload;
    },
    setProfileTabSelected: (state, action) => {
      state.profileTabSelected = action.payload;
    },
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    setLoginDetails: (state, action) => {
      console.log("setLoginDetails", action.payload);
      state.accessToken = action.payload.token;

      const ssoRole = getSsoRole(action.payload);
      if (ssoRole) {
        state.userRole = ssoRole;
      }

      if (action.payload.employee_id) {
        state.refreshToken = action.payload.refresh_token;
        state.customToken = action.payload.custom_token;
        state.employeeID = action.payload.employee_id;

        if (shouldForceHrRole(state, action.payload)) {
          state.loginResponse = {
            ...state.loginResponse,
            ...action.payload,
            role_type: "HR",
            body: {
              ...(state.loginResponse?.body || {}),
              role_type: "HR",
            },
          };
        } else {
          state.loginResponse = { ...state.loginResponse, ...action.payload };
        }
      }
    },
    setEmployeeID: (state, action) => {
      state.employeeID = action.payload;
    },

    resetUserDetails: (state, action) => {
      state.userDetailsResponse = null;
      state.userDetailsResponseStatus = null;
    },
    logout: (state, action) => {
      state.isLoggedIn = false;
      state.accessToken = null;
      state.refreshToken = null;
      state.loginResponseStatus = null;
      state.loginResponse = null;
      localStorage.clear();
    },
    setUserLoginData: (state, action) => {
      state.employeeID = action.payload?.employeeID;
      state.loginResponse = { ...state.loginResponse, ...action.payload };
    },

    setInitialState: (state) => {
      return initialState;
    },
  },
  extraReducers: (builder) => {
    //GET SIMPLUS SIGN IN TOKEN
    builder.addCase(login.pending, (state, action) => {
      state.loginResponseStatus = null;
    });
    builder.addCase(login.rejected, (state, action) => {
      state.loginResponseStatus = "ERROR";
      state.loginResponse = action.payload;
    });
    builder.addCase(login.fulfilled, (state, action) => {
      let loginPayload = action.payload;

      if (shouldForceHrRole(state, action.payload)) {
        loginPayload = {
          ...action.payload,
          role_type: "HR",
          body: {
            ...(action.payload?.body || {}),
            role_type: "HR",
          },
        };
      }

      state.loginResponse = { ...state.loginResponse, ...loginPayload };
      localStorage.setItem(
        "user",
        JSON.stringify({
          ...loginPayload,
          employeeID: state.employeeID,
          loginTime: new Date(),
        })
      );

      if (loginPayload?.status === "success")
        state.loginResponseStatus = "SUCCESS";
      else if (loginPayload?.status === "error")
        state.loginResponseStatus = "ERROR";
    });

    builder.addCase(getUserDetails.pending, (state, action) => {
      state.userDetailsResponse = null;
      state.userDetailsResponseStatus = "PENDING";
    });
    builder.addCase(getUserDetails.rejected, (state, action) => {
      state.userDetailsResponse = action.payload;
      state.userDetailsResponseStatus = "ERROR";
    });
    builder.addCase(getUserDetails.fulfilled, (state, action) => {
      state.userDetailsResponse = action.payload;
      state.userDetailsResponseStatus = "SUCCESS";
    });

    builder.addCase(updateUserProfileInfo.pending, (state, action) => {
      state.updateProfileInfoResponse = null;
      state.updateProfileInfoResponseStatus = "PENDING";
    });
    builder.addCase(updateUserProfileInfo.rejected, (state, action) => {
      state.updateProfileInfoResponse = action.payload;
      state.updateProfileInfoResponseStatus = "ERROR";
    });
    builder.addCase(updateUserProfileInfo.fulfilled, (state, action) => {
      state.updateProfileInfoResponse = action.payload;
      state.updateProfileInfoResponseStatus = "SUCCESS";
    });
  },
});

export const authActions = authSlice.actions;

export default authSlice.reducer;
